define('meetings/lib/phone-upsell/phone-upsell',['require','durandal/app','knockout','i18next','api-access','api-access','web-urls','lodash'],function (require) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var i18n = require('i18next');
    var userApi = require('api-access').user;
    var commerceApi = require('api-access').commerce;
    var webUrls = require('web-urls');
    var _ = require('lodash');

    var self = this;

    self.phoneUpsell = ko.observable();

    var isBillingAdmin;
    var nativeEndpointDisabled;
    var noTollCountries;
    var noTollFreeCountries;
    var userKey;

    // Set the phoneupsell flag
    $.when(
        userApi.me(),
        userApi.settings()
    ).then(function (userResp, settingsResp) {
        userKey = userResp[0].key;
        nativeEndpointDisabled = settingsResp[0].nativeEndpointDisabled;
        noTollCountries = _.get(settingsResp[0], 'audio.allowedTollCountries.length') === 0;
        noTollFreeCountries = _.get(settingsResp[0], 'audio.allowedTollFreeCountries.length') === 0;

        return commerceApi.getProducts();
    }).then(function (products) {
        var product = _.find(products, {product: 'GoToMeeting'}) || {};

        isBillingAdmin = userKey === product.billingAdminUserKey;

        if (isBillingAdmin && nativeEndpointDisabled && (noTollCountries || noTollFreeCountries)) {
            self.phoneUpsell(true);
        } else {
            self.phoneUpsell(false);
        }
    })
    .fail(function () {
        self.phoneUpsell(false);
    });

    self.addPhoneNumbers = function () {
        var billingInfoUrl = webUrls.get('buyUpgradeUrl');

        var viewRateslink =
          '<a href="' + webUrls.get('citrixHelp') + '" target="_blank">' + i18n.t('phoneUpsell.upsellModal.viewRates') +
          '</a>';

        var rateInfo =
          '<b>' + i18n.t('phoneUpsell.upsellModal.rate') + '</b>';

        var messageHTML =
          '<ul>' +
            '<li>' + i18n.t('phoneUpsell.upsellModal.upsellMsg1') + '</li>' +
            '<li>' + i18n.t('phoneUpsell.upsellModal.upsellMsg2') + '</li>' +
            '<li>' + i18n.t('phoneUpsell.upsellModal.upsellMsg3') + viewRateslink + '</li>' +
            '<li>' + rateInfo + i18n.t('phoneUpsell.upsellModal.upsellMsg4') + '</li>' +
          '</ul>';

        var addPhoneNumbersModal = {
            message: messageHTML,
            title: i18n.t('phoneUpsell.upsellModal.title'),
            options: [
              {text: i18n.t('phoneUpsell.upsellModal.addBillingInfo'), value: true},
              {text: i18n.t('phoneUpsell.upsellModal.notNow'), value: false}
            ],
            autoClose: true,
            settings: {
                buttonClass: 'btn',
                primaryButtonClass: 'btn-primary',
                secondaryButtonClass: 'btn-secondary',
                style: {width: '620px'}
            }
        };

        app.showMessage(
          addPhoneNumbersModal.message,
          addPhoneNumbersModal.title,
          addPhoneNumbersModal.options,
          addPhoneNumbersModal.autoClose,
          addPhoneNumbersModal.settings,
          addPhoneNumbersModal.style
        ).then(function (goToBillingInfo) {
            if (goToBillingInfo) {
                window.location.href = billingInfoUrl;
            }
        });
    };

    return self;
});

